import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=90752e62&scoped=true&"
import script from "./AppPagination.vue?vue&type=script&lang=js&"
export * from "./AppPagination.vue?vue&type=script&lang=js&"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=90752e62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90752e62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VImg,VPagination})
